<template>
	<div :class="{active}" class="pagination-button-wrapper">
		<p>{{finalValue}}</p>
	</div>
</template>

<script>
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import AppInPlaceCloud from "@/shared/components/AppInPlaceCloud.vue";
import AppButton from "@/shared/components/AppButton.vue";

import {useSvgStore} from "@/shared/stores";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		const languageStore = useLanguageStore();
		return { getIcon: svgStore.get, getString: languageStore.getString }
	},
	components: {
		AppClickableIcon,
		AppInPlaceCloud,
		AppButton,
	},
	name: "AppPaginationButton",
	emits: [],
	data() {
		return {

		}
	},
	props: {
		value: {type: Number, default: 1},
		active: {type: Boolean, default: false},
	},
	computed: {
		finalValue() {
			return this.value ? this.value : '...';
		}
	},
}
</script>

<style lang="scss" scoped>

.pagination-button-wrapper {
	user-select: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 20px;
	padding: 3px;
	margin: 0 2px;
	position: relative;

	p {
		font-size: 12px;
		line-height: 14px;
		pointer-events: none;
		margin: 0;
	}
	&:hover p {
		transform: scale(1.05);
		transition: transform .2s ease;
	}
	&:active p {
		transform: scale(0.99);
		transition: transform .08s ease;
	}

	&:before,
	&:after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		right: 0;
		height: 3px;
		border-radius: 2.5px;
		background-color: var(--color-bg-primary-4);
		transform: translateX(-100%);
		transition: transform 0.3s ease-in-out, width 0.3s ease-in-out, opacity 0.3s ease-in;
	}

	&:before, &:after {
		z-index: -1;
		width: 0;
		opacity: 0;
	}

	&:after {
		z-index: 1;
	}

	&:hover:before,
	&:hover:after {
		transform: translateX(0);
		width: 100%;
		opacity: 1;
	}

	&:active:before,
	&:active:after {
		transform: translateX(100%);
		width: 0;
		opacity: 0;
	}

	&:hover:not(:active):before {
		width: 50%;
		opacity: 0.5;
	}

	&.active:before, &.active:hover:before, &.active:active:before {
		width: 100%;
		transform: translateX(0);
		opacity: 1;
		z-index: unset;
	}
	&.active:after, &.active:hover:after, &.active:active:after {
		visibility: hidden;
	}

}

</style>